module.exports = __webpack_public_path__ + "assets/img/car09.8fc7f355.jpg";